/**
 * Sensor Types Model
 */
const SENSOR_TYPES = {
    production: {
        label: 'Gross'
    },
    gross: {
        label: 'Gross'
    },
    reject: {
        label: 'Reject'
    },
    net: {
        label: 'Net'
    },
    proximity: {
        label: 'Proximity'
    }
};

export { SENSOR_TYPES };
